import { create } from "zustand";
import { ConsultantState } from "@/app/store";

export interface ConsultantStore {
	readonly consultantState: ConsultantState;
	setConsultantState: (consultant: ConsultantState) => void;
	getConsultantState: () => ConsultantState;
}

export const useConsultantStore = create<ConsultantStore>((set, get) => {
	return {
		consultantState: {
			status: "not-connected"
		},

		setConsultantState: (consultantState: ConsultantState): void => {
			set({ consultantState });
		},

		getConsultantState: (): ConsultantState => {
			return get().consultantState;
		}
	};
});
